/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

//table columns for user management table listing 
export const columns: TableColumn[] = [
    {
        Header: 'tableCommon.sl_no',
        accessor: 'slno',
      },
      {
        Header: 'equipmentCalibration.tableColumns.name',
        accessor: 'name',
      },
      {
        Header: 'equipmentCalibration.tableColumns.equipment_code',
        accessor: 'equipment_code',
      },
      {
        Header: 'tableCommon.equipment_type',
        accessor: 'type_name',
      },
      {
        Header: 'equipmentCalibration.tableColumns.calibrated_details',
        accessor: 'calibration_details',
      },
      {
        Header: 'equipmentCalibration.tableColumns.capacity',
        accessor: 'capacity',
      },
]

interface TableColumn {
    Header: string;
    accessor: string;
  }
